import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({

  labelIcon: {
    height: 40,
    position: "relative",
    zIndex: 1,
    cursor: "pointer",
    [emulatorScreen(theme)]: {
      height: 30,
    },
    [mobileScreen(theme)]: {
      height: 30,
    },
  },
  dragableDiv: {
    justifyContent: 'center', alignItems: 'center', height: 35, width: 40, position: "relative", zIndex: 12, cursor: "pointer",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 26, width: 35,
    },
  },
  shadowDiv: {
    justifyContent: 'center', alignItems: 'center', height: 35, width: 40,  marginLeft: 3, marginTop: 7, cursor: "pointer", border: "1.5px solid #003e4c", borderRadius: 5, backgroundColor: "#003e4c", zIndex: 0, position: 'absolute',
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 26, width: 35,
    },
  },
  textContainer: {
    justifyContent: 'center', alignItems: 'center', height: 35, position: "relative", zIndex: 1, cursor: "pointer", border: "1.5px solid #003e4c", borderRadius: 5, backgroundColor: "#fff",
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      height: 26, width: 35,
    },
  },

  text:{
    color: "#003e4c", fontSize: 24, fontFamily: "Rubik", letterSpacing: 1, marginTop: -3,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18
    },
  }
});

export default styles;
